import React from "react";
import "./RelevantInfo.css";

import pbMagazine from "../../../assets/images/pbMagazine.png";
import qualityControl from "../../../assets/images/qualityControl.jpg";

const RelevantInfo = () => {
  return (
    <div className="flex flex-col lg:flex-row">
      <div className="relative flex-1 flex">
        <div className="relative sm:absolute bg-red-700 sm:bg-transparent flex flex-col sm:flex-row p-5 w-full h-full">
          <div>
            <span className="bg-red-700 bg-opacity-50 p-1 text-2xl text-white">Quality Control</span>
          </div>
          <div className="description flex-1 flex flex-col justify-center bg-red-700 bg-opacity-50 mt-1 sm:mt-10 sm:ml-1 p-4 text-white text-center">
            <span>2021 - Zeiss Spectrum CMM</span>
            <span>Production Part Approval Process (PPAP)</span>
            <span>American Society of Quaspanty Standard (ASQ)</span>
            <span>First Article Inspection (FAI)</span>
            <span>First Article Approval (FAA)</span>
            <span>Certificate of Conformity (CoC)</span>
            <span>Material Texting</span>
          </div>
        </div>
        <img
          className="relevant-qt-img object-cover hidden sm:inline"
          alt="quality-control"
          src={qualityControl}
        />
      </div>
      <div className="flex-1 flex relevant-container">
        <div className="flex-1 bg-gray-800 p-4">
          <span className="text-2xl text-white">
            Transforming Manufacturing
          </span>
            <ul className="ml-6 mt-2 list-disc text-white text-sm">
              <li className="description">Shop Management Software</li>
              <li className="description">
                Quick Change Machining
                <ul className="ml-2 mb-2 list-disc italic">
                  <li className="description">3-4-5th Axis</li>
                  <li className="description">Homogeneous Machines</li>
                </ul>
              </li>
              <li className="description">
                2/7 Blended Operation
                <ul className="ml-2 mb-2 list-disc italic">
                  <li>Prototypes &</li>
                  <li>Production</li>
                </ul>
              </li>
            </ul>
        </div>
        <div className="hidden sm:inline">
          <img
            className="object-cover relevant-magazine"
            alt="magazine"
            src={pbMagazine}
          />
        </div>
      </div>
    </div>
  );
};

export default RelevantInfo;
